import * as React from "react";
export class StatsLegendItem extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-aggregate-stats-info-item" },
            React.createElement("span", { className: `icon i-12 ${this.props.iconClass}` }),
            React.createElement("span", { className: "rj-aggregate-stats-info-item--text" }, this.props.dict[this.props.text])));
    }
}
//# sourceMappingURL=StatsLegendItem.js.map